import {Component, OnInit, signal} from '@angular/core';
import {CordovaService} from "../cordova.service";
import {Router, RouterLink} from "@angular/router";
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'app-lmra',
    templateUrl: './lmra.component.html',
    styleUrls: ['./lmra.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatRadioGroup,
        MatRadioButton,
        FormsModule
    ]
})
export class LMRAComponent implements OnInit {

    readonly questions = signal<Question[]>([]);
    private questionTexts = [
        'Weet ik welk werk ik moet doen?',
        'Weet ik hoe ik het werk moet aanpakken?',
        'Heb ik de juiste, gekeurde gereedschappen?',
        'Draag ik de juiste werkkleding en PBM’s?',
        'Is het werkvak goed afgezet?',
        'Kan ik veilig werken?',
    ];

    constructor(private router: Router,
                private cordovaService: CordovaService) {
    }

    ngOnInit(): void {
        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        let previousQuestion = null;
        const questionList: Question[] = [];
        this.questionTexts.forEach(text => {
            const question = new Question();
            question.question = text;
            question.previousQuestion = previousQuestion;
            questionList.push(question);
            previousQuestion = question;
        });
        this.questions.set(questionList);
    }

    questionChange(event, question) {
        if (!event.value) {
            const index = this.questions().indexOf(question);
            this.questions().slice(index + 1).forEach(q => q.answer = null);
        }
    }
}

export class Question {
    question: string;
    answer: boolean;
    previousQuestion: Question;
}
